import * as React from 'react';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { ObjectUtils } from "src/core/utils/object";

interface Props {
	value?: number;
	request: DropdownRequest<PolicySummary>;
	label?: string;
	required?: boolean;
	mode: ControlMode;
	onChange: (value?: PolicySummary) => void;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

const optionRenderer = (e: PolicySummary): React.ReactNode => {
	return `${e.displayName} (${ObjectUtils.round(e.commission * 100)}%)`;
}

export const PolicyEditorView = (props: Readonly<Props>) => {
	const { value, mode, required, request, onChange, onGetErrorMessage } = props;
	let { label } = props;
	if (label === undefined) {
		label = 'Policy';
	}

	return (
		<DropdownView
			label={label}
			model={value}
			keyField="id"
			textField="displayName"
			optionRenderer={optionRenderer}
			disabled={mode == 'display'}
			required={required}
			request={request}
			onChanged={onChange}
			onGetErrorMessage={onGetErrorMessage}
		/>
	);
};



// WEBPACK FOOTER //
// ./src/app/bookings/policies/parts/policy-editor.view.tsx